<template>
  <span
    :id="'XVhelpcontrol' + id"
    class="XVhelpcontrol"
    @click="helpClick()"
    @mouseenter="helpHover()"
    @mouseleave="helpremove()"
    v-if="helptext !== '' && helptext !== ' ' && helptext !== '&nbsp;'"
  >
    <font-awesome-icon :icon="['far', 'question-circle']" class="fa-1x graphQuestion" />
  </span>
</template>
<script>
import { FAMixin, util } from 'pevueglobal'
import { mapMutations, mapGetters } from 'vuex'

export default {
  mixins: [FAMixin],
  name: 'XVhelpcontrol',
  props: {
    helptext: {
      type: String,
      required: true,
      default: ''
    },
    bightml: {
      type: Boolean,
      default: false
    },
    titel: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      id: null,
      Ititel: '',
      timeout: null
    }
  },
  methods: {
    ...mapMutations(['addNotification']),
    helpClick() {
      if ($('body').hasClass('mobile')) {
        this.addNotification({
          groupname: 'primary',
          message: this.helptext,
          sticky: false,
          title: '',
          guid: util.guid(),
          bightml: this.bightml,
          removegroup: true
        })
        // overlib(this.helptext, this, null, this.bightml)
      }
    },
    helpHover() {
      if (!$('body').hasClass('mobile')) {
        this.timeout = setTimeout(() => {
          this.addNotification({
            groupname: 'primary',
            message: this.helptext,
            sticky: false,
            title: '',
            guid: util.guid(),
            bightml: this.bightml,
            removegroup: true
          })
        }, 500)
      }
    },
    helpremove() {
      clearTimeout(this.timeout)
    }
  },
  computed: {
    ...mapGetters(['notifications'])
  },
  mounted: function() {
    this.id = this._uid
    if (this.titel === '') {
      this.Ititel = this.translation(112)
    }
  }
}
</script>
